import React, {Fragment} from "react";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import {searchGroupGuests, searchProviderGuests,} from "../../../../api/pro-guest-functions";
import {TableLoadingRow} from "../../../ui/table/TableLoadingRow";
import {makeStyles} from "@material-ui/core/styles/index";
import {withLazyDynamicTable} from "../../../ui/hoc/LazyDynamicTable";
import {TableEmptyRow} from "../../../ui/table/TableEmptyRow";

const useStyles = makeStyles(theme => ({
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    }
}));


const _Guests = ({
                     organizationId,
                     folderId,
                     groupId,
                     refresh,
                     headerRender,
                     rowRender,
                     data: guests,
                     loading
                 }: any) => {

    return (<Fragment>
        <TableHead>
            {headerRender()}
        </TableHead>
        <TableBody>
            {
                loading ? <TableLoadingRow/> :
                    guests.length === 0 ?
                        <TableEmptyRow messageKey='ProGuest.Guests.Table.EmptyMessage'/> :
                        guests.map(rowRender)
            }
        </TableBody>
    </Fragment>);
};

export const Guests = (properties: any) => {
    const {groupId, folderId, organizationId, onlyPending} = properties;
    const query = (searchArgs: any) => groupId ?
        searchGroupGuests({...searchArgs, organizationId, folderId, groupId, onlyPending}) :
        searchProviderGuests({...searchArgs, organizationId});
    return withLazyDynamicTable(_Guests, query, ['groupId', 'folderId', 'organizationId'])(properties);
};
